import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Emit } from "vue-property-decorator";

var PickerInput =
/*#__PURE__*/
function (_Vue) {
  _inherits(PickerInput, _Vue);

  function PickerInput() {
    _classCallCheck(this, PickerInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(PickerInput).apply(this, arguments));
  }

  _createClass(PickerInput, [{
    key: "clickInput",
    value: function clickInput() {}
  }]);

  return PickerInput;
}(Vue);

tslib_1.__decorate([Prop()], PickerInput.prototype, "textData", void 0);

tslib_1.__decorate([Prop()], PickerInput.prototype, "placeHolder", void 0);

tslib_1.__decorate([Emit('clickInput')], PickerInput.prototype, "clickInput", null);

PickerInput = tslib_1.__decorate([Component({
  components: {}
})], PickerInput);
export default PickerInput;